import { useQuery } from '@tanstack/react-query';
import { fetchRecentActivities, ActivitiesResponse } from '../adapters/recentActivitiesAdapter';

export const useRecentActivities = () => {
  return useQuery<ActivitiesResponse, Error>({
    queryKey: ['dashboard', 'recent-activities'],
    queryFn: fetchRecentActivities,
    refetchOnWindowFocus: false,
  });
};
